import { ORDER_API_PATH } from "../config/apiPaths";
import { getRequest } from "./config/GetRequest";
import { postRequest } from "./config/PostRequest";

export const listRequest = () => async () => {
  try {
    let result = await getRequest(ORDER_API_PATH.LIST_PATH, null, false);
    return result;
  } catch (error) {
    // TODO Handle Error
  }
};

export const createUpdateRequest = (data) => async () => {
  try {
    let result = await postRequest(
      ORDER_API_PATH.CREATE_UPDATE_PATH,
      data,
      false
    );
    return result;
  } catch (error) {
    // TODO Handle Error
    return error;
  }
};

export const updateStatusRequest = (data) => async () => {
  try {
    let result = await postRequest(
      ORDER_API_PATH.UPDATE_ORDER_STATUS,
      data,
      false
    );
    return result;
  } catch (error) {
    // TODO Handle Error
    return error;
  }
};
